<template>
    <div>
        <Form :model="formData">
            <FormItem label="Account" :label-width="80" prop="templateId">
                <vSelect v-model="formData.AccountId" filterable clearable>
                    <vOption v-for="item in getChooseAccountList" :value="item.value" :key="item.value">{{item.label}}</vOption>
                </vSelect>
            </FormItem>
        </Form>
        <compUpload v-bind="getFileProps" @on-success="$emit('on-update')" @on-close="$emit('on-close')"></compUpload>
    </div>
</template>
<script>
import { mapState,mapGetters } from "vuex";
export default {
    props:['importType','actionurl'],
    components: {
        compUpload: () =>  import("@components/templates/upload"),
    },
    data () {
        return {
            formData:{

                AccountId:''
            }
        }
    },
    computed:{
        ...mapGetters('diction',['getNewAccountIdList']),
        getChooseAccountList(){
            return this.getNewAccountIdList.filter(function(item){
                return item.attach.item.type == 'amazonvendor'
            })
        }, 
        getFileProps() {
			return {
                name: "excelFile",
				data: {
                    accountId:this.formData.AccountId,
                },
				action: this.actionurl,
			}
		},   
    },
    methods: {
        
    }
}
</script>